import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CreateReactClass from 'create-react-class';

import Getters from 'data/getters';
import Reactor from 'data/reactor';
import Actions from 'data/actions';
import { findShowMethodForModal } from 'utils/runtime';
import { sharedModalReferences } from 'resources/common-values';
import Analytics from 'utils/analytics';
import CommonValues from 'resources/common-values';
import StudentsList from './student-list';
import Popover from 'utils/popover';
import { DeepCompareComponentShouldUpdateMixin } from 'utils/react';

export default CreateReactClass({
    displayName: 'StudentListButton',
    mixins: [Reactor.ReactMixin, DeepCompareComponentShouldUpdateMixin],

    getDataBindings() {
        /* showStudentList is only called here and does not need to be trickled down from props
         * openHelpBoxId is used in a stately manner
         * */
        return {
            showStudentList: Getters.runtime.studentListOpen,
            openHelpBoxId: Getters.runtime.openHelpBoxId,
        };
    },

    propTypes: {
        unsavedData: PropTypes.bool,
        students: PropTypes.instanceOf(Immutable.List).isRequired,
        selectedClass: PropTypes.instanceOf(Immutable.Map).isRequired,
        modalReferences: PropTypes.object,
    },

    handleClickWithinStudentListBox(event) {
        event.stopPropagation();
    },

    toggleStudentList(event) {
        const action = () => {
            Actions.runtime.toggleStudentListPopover(!this.state.showStudentList);
        };
        Popover.closeOpenPopovers('StudentList');
        Popover.closeChartPopoverBoxes(event);

        Analytics.recordButtonClick(
            CommonValues.SectionIDs.studentInfo,
            'open-class-list',
            this.props.students.isEmpty() ? 'no-students' : ''
        );

        if (this.props.unsavedData) {
            const showSaveDataPrompt = findShowMethodForModal(
                this.props.modalReferences,
                sharedModalReferences.saveDataPrompt
            );
            showSaveDataPrompt()
                .then(() => {
                    action();
                    Actions.runtime.setUnsavedData(false);
                })
                .catch(() => {
                    /* do nothing */
                });
        } else {
            action();
        }
    },

    handleClickWithinBox(event) {
        event.stopPropagation();
    },

    render() {
        const modifyLocation = __DEV__ ? '/students' : '/nextgen-report/students';
        const popoverDisplay = this.state.showStudentList ? 'show-fade jump-up-z-index' : 'hide-fade';

        let buttons = [];
        if (this.props.students && this.props.students.size > 0) {
            buttons.push(
                <Link
                    className="btn btn-default text-uppercase"
                    id="modify-selection-btn"
                    key="modify-selection-btn"
                    onClick={() => {
                        Popover.closeOpenPopovers('');
                        Analytics.recordButtonClick(CommonValues.SectionIDs.studentInfo, 'return-to-create-report');
                        window.location = modifyLocation;
                    }}
                >
                    Modify Selection
                </Link>
            );
        }

        buttons.push(
            <Button
                className="text-uppercase pull-right"
                bsStyle="danger"
                key="close-student-list"
                onClick={this.toggleStudentList}
            >
                CANCEL
            </Button>
        );

        return (
            <div
                className="student-list-popover"
                id="student-list-popover"
                key="student-list-popover"
                onClick={this.handleClickWithinBox}
            >
                <button className="student-list-btn" key="student-icon-button" onClick={this.toggleStudentList}>
                    <i className="icon icon-student-list" key="student-list-icon"></i>
                </button>
                <div
                    data-testid="student-list-popover-content"
                    className={`${popoverDisplay} popover-content`}
                    key="student-list-content"
                >
                    <div className="popover-title">
                        {this.props.students && this.props.students.size > 0
                            ? this.props.selectedClass.get('name')
                            : ''}
                    </div>
                    <StudentsList students={this.props.students} key="student-list-data"></StudentsList>
                    <div className="student-list-footer clearfix" key="student-list-footer">
                        {buttons}
                    </div>
                </div>
            </div>
        );
    },
});
